import { render } from "./ChapterTutorialAnimation.vue?vue&type=template&id=5dc79356&scoped=true&ts=true"
import script from "./ChapterTutorialAnimation.vue?vue&type=script&lang=ts"
export * from "./ChapterTutorialAnimation.vue?vue&type=script&lang=ts"

import "./ChapterTutorialAnimation.vue?vue&type=style&index=0&id=5dc79356&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc79356"]])

export default __exports__